var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [_vm._m(0), _vm._v(" "), _c("app-backend-footer")],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container-fluid xyz" }, [
      _c("div", { staticClass: "page-header-top-container" }, [
        _c("div", { staticClass: "page-name" }, [_vm._v("Timeline")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "admin-page-content" }, [
        _c(
          "div",
          {
            staticClass:
              "timeline-main-section col-12 float-l default-bx-shadow"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "timeline" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-end justify-content-md-around align-items-start  timeline-nodes"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-10 col-md-5 order-3 order-md-1 timeline-content"
                      },
                      [
                        _c("h3", [_vm._v("Lorem ipsum")]),
                        _vm._v(" "),
                        _c("h5", [_vm._v(" 11 hours ago via Twitter")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-2 col-sm-1 order-2 timeline-image text-md-center"
                      },
                      [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: "/static/images/avtar-img.jpg",
                            alt: "img"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "col-10 col-md-5 order-1 order-md-3 py-3 timeline-date"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-end justify-content-md-around align-items-start  timeline-nodes"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-10 col-md-5 order-3 order-md-1 timeline-content"
                      },
                      [
                        _c("h3", [_vm._v("Lorem ipsum")]),
                        _vm._v(" "),
                        _c("h5", [_vm._v(" 11 hours ago via Twitter")]),
                        _vm._v(" "),
                        _c("img", {
                          staticClass: "timeline-img",
                          attrs: { src: "/static/images/timeline-demo-img.jpg" }
                        }),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-2 col-sm-1 order-2 timeline-image text-md-center"
                      },
                      [
                        _c("img", {
                          staticClass: "img-fluid",
                          attrs: {
                            src: "/static/images/avtar-img-1.jpg",
                            alt: "img"
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "col-10 col-md-5 order-1 order-md-3 py-3 timeline-date"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-end justify-content-md-around align-items-start  timeline-nodes"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-10 col-md-5 order-3 order-md-1 timeline-content"
                      },
                      [
                        _c("h3", [_vm._v("Lorem ipsum")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-2 col-sm-1 order-2 timeline-image text-md-center"
                      },
                      [
                        _c("i", {
                          staticClass:
                            "hi-icon icon-abmsettings bg-color-29a3b0 timeline-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "col-10 col-md-5 order-1 order-md-3 py-3 timeline-date"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "row justify-content-end justify-content-md-around align-items-start  timeline-nodes"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-10 col-md-5 order-3 order-md-1 timeline-content"
                      },
                      [
                        _c("h3", [_vm._v("Lorem ipsum")]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis."
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-2 col-sm-1 order-2 timeline-image text-md-center"
                      },
                      [
                        _c("i", {
                          staticClass:
                            "hi-icon icon-abmweb bg-color-d7757c timeline-icon"
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "col-10 col-md-5 order-1 order-md-3 py-3 timeline-date"
                    })
                  ]
                )
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756f97d1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756f97d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/timeline.vue
// module id = null
// module chunks = 